
// // === ManagerProfile.jsx ===
// import React, { useEffect, useState, useMemo } from "react";
// import { useApp } from "../../../context/AppContext";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import Input from "../../../components/Form/Input";
// import Button from "../../../components/Form/Button";
// import { useToast } from "../../../context/ToastContext";
// import apiService from "../../../services/api"; // ⭐ <-- use pump API directly
// import "./Profile.css";

// const ManagerProfile = () => {
//   const { currentUser, updateProfile, fetchCurrentProfile } = useApp();
//   const { showToast } = useToast();

//   const [pumpData, setPumpData] = useState(null);
//   const [loadingPump, setLoadingPump] = useState(true);

//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     pumpName: "",
//     city: "",
//   });

//   // ================================
//   //   FETCH PUMP INFO FROM API
//   // ================================
//   useEffect(() => {
//     const fetchPumpInfo = async () => {
//       setLoadingPump(true);

//       const response = await apiService.getPumpsForManager();

//       // response.data contains your array
//       const pumpList = response?.data ?? [];

//       // find pump of this manager
//       const matched = pumpList.find((p) => {
//         if (!p || !currentUser) return false;
//         return (
//           String(p.manager_id) === String(currentUser._id) ||
//           String(p.managerId) === String(currentUser._id) ||
//           String(p.managerPhone) === String(currentUser.phone)
//         );
//       });

//       setPumpData(matched || null);
//       setLoadingPump(false);
//     };

//     fetchPumpInfo();
//   }, [currentUser]);

//   // =====================================
//   //   LOAD PROFILE + PUMP INTO FORM
//   // =====================================
//   useEffect(() => {
//     setFormData({
//       name: currentUser?.name ?? "",
//       phone: currentUser?.phone ?? "",
//       pumpName:
//         pumpData?.brand ||
//         pumpData?.pumpName ||
//         pumpData?.name ||
//         "",
//       city:
//         pumpData?.city ||
//         pumpData?.address?.locality ||
//         "",
//     });
//   }, [currentUser, pumpData]);

//   // =====================================
//   //         FORM CHANGE HANDLER
//   // =====================================
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // =====================================
//   //         SUBMIT HANDLER
//   // =====================================
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!currentUser) {
//       showToast("No profile loaded", "error");
//       return;
//     }

//     try {
//       const payload = {
//         name: formData.name,
//         phone: formData.phone,
//       };

//       await updateProfile(payload);
//       showToast("Profile updated successfully!", "success");

//       await fetchCurrentProfile();
//     } catch (err) {
//       console.error("Failed to update profile:", err);
//       showToast("Failed to update profile", "error");
//     }
//   };

//   return (
//     <div className="manager-profile">
//       <PageHeader title="Profile" />

//       <div className="profile-container">
//         <form onSubmit={handleSubmit} className="profile-form">
//           <div className="profile-section">
//             <h2 className="profile-section-title">Personal Information</h2>

//             <div className="profile-grid">
//               <Input label="Name" name="name" value={formData.name} onChange={handleChange} required />
//               <Input label="Phone" name="phone" value={formData.phone} onChange={handleChange} required />
//             </div>
//           </div>

//           <div className="profile-section">
//             <h2 className="profile-section-title">Pump Information</h2>

//             <div className="profile-grid">
//               <Input
//                 label="Pump Name"
//                 name="pumpName"
//                 value={formData.pumpName}
//                 onChange={handleChange}
//                 disabled
//               />
//               <Input
//                 label="City"
//                 name="city"
//                 value={formData.city}
//                 onChange={handleChange}
//                 disabled
//               />
//             </div>

//             <p className="profile-note">💡 Pump information can only be changed by administrators.</p>
//           </div>

//           <div className="profile-actions">
//             <Button type="submit" variant="primary">
//               Save Changes
//             </Button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ManagerProfile;


// === ManagerProfile.jsx ===
import React, { useEffect, useState } from "react";
import { useApp } from "../../../context/AppContext";
import PageHeader from "../../../components/PageHeader/PageHeader";
import Input from "../../../components/Form/Input";
import Button from "../../../components/Form/Button";
import { useToast } from "../../../context/ToastContext";
import apiService from "../../../services/api"; // ⭐ uses pump API directly
import "./Profile.css";

const ManagerProfile = () => {
  const { currentUser, updateProfile, fetchCurrentProfile } = useApp();
  const { showToast } = useToast();

  const [pumpData, setPumpData] = useState(null);
  const [loadingPump, setLoadingPump] = useState(true);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    pumpName: "",
    city: "",
    rate: "", // new field for rate
  });

  // ================================
  //   FETCH PUMP INFO FROM API
  // ================================
  useEffect(() => {
    const fetchPumpInfo = async () => {
      setLoadingPump(true);
      try {
        const response = await apiService.getPumpsForManager();
        const pumpList = response?.data ?? [];

        const matched = pumpList.find((p) => {
          if (!p || !currentUser) return false;
          return (
            String(p.manager_id) === String(currentUser._id) ||
            String(p.managerId) === String(currentUser._id) ||
            String(p.managerPhone) === String(currentUser.phone)
          );
        });

        setPumpData(matched || null);
      } catch (err) {
        console.error("Failed to fetch pump info:", err);
        showToast("Failed to load pump information", "error");
        setPumpData(null);
      } finally {
        setLoadingPump(false);
      }
    };

    if (currentUser) fetchPumpInfo();
  }, [currentUser, showToast]);

  // =====================================
  //   LOAD PROFILE + PUMP INTO FORM
  // =====================================
  useEffect(() => {
    setFormData({
      name: currentUser?.name ?? "",
      phone: currentUser?.phone ?? "",
      pumpName:
        pumpData?.brand ||
        pumpData?.pumpName ||
        pumpData?.name ||
        "",
      city:
        pumpData?.city ||
        pumpData?.address?.locality ||
        "",
      // try multiple common keys for rate/price
      rate:
        pumpData?.rate ??
        pumpData?.price ??
        pumpData?.ratePerLitre ??
        pumpData?.fuelRate ??
        "",
    });
  }, [currentUser, pumpData]);

  // =====================================
  //         FORM CHANGE HANDLER
  // =====================================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // =====================================
  //         SUBMIT HANDLER
  // =====================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      showToast("No profile loaded", "error");
      return;
    }

    setSaving(true);
    try {
      // 1) Update user profile (existing)
      const profilePayload = {
        name: formData.name,
        phone: formData.phone,
      };

      await updateProfile(profilePayload);
      showToast("Profile updated successfully!", "success");

      // 2) Update pump if we have one (or if pump fields were manually added by manager)
      const currentPumpName = pumpData?.brand || pumpData?.name || pumpData?.pumpName || "";
      const currentCity = pumpData?.city || pumpData?.address?.locality || "";
      const currentRate = pumpData?.rate ?? pumpData?.price ?? pumpData?.ratePerLitre ?? pumpData?.fuelRate ?? "";

      const didPumpChange =
        pumpData &&
        (
          formData.pumpName !== currentPumpName ||
          formData.city !== currentCity ||
          // compare as strings/numbers normalized
          String(formData.rate) !== String(currentRate)
        );

      if (pumpData && didPumpChange) {
        const pumpId = pumpData._id || pumpData.id;
        if (!pumpId) {
          console.warn("Pump found but no id present:", pumpData);
          showToast("Pump ID missing — could not update pump", "error");
        } else {
          // Build a sensible payload for the pump update.
          // Adjust field names to match your backend schema if needed.
          const parsedRate =
            formData.rate !== "" && formData.rate !== null
              ? Number.parseFloat(formData.rate)
              : undefined;

          const pumpPayload = {
            // common fields you likely have: brand/name/pumpName, city, and also an address block
            brand: formData.pumpName,
            name: formData.pumpName, // keep both for safety
            pumpName: formData.pumpName,
            city: formData.city,
            // include rate only if provided / valid number
            ...(parsedRate !== undefined && !Number.isNaN(parsedRate) ? { rate: parsedRate } : {}),
            // if backend expects address object:
            address: {
              ...(pumpData.address || {}),
              locality: formData.city,
            },
          };

          await apiService.updatePump(pumpId, pumpPayload);

          // Refresh local pumpData with updated values (optimistic)
          setPumpData((prev) => ({
            ...(prev || {}),
            ...pumpPayload,
          }));

          showToast("Pump information updated successfully!", "success");
        }
      }

      // refresh the current profile from server
      await fetchCurrentProfile();
    } catch (err) {
      console.error("Failed to update profile or pump:", err);
      const msg = err?.response?.data?.message || "Failed to update profile or pump";
      showToast(msg, "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="manager-profile">
      <PageHeader title="Profile" />

      <div className="profile-container">
        <form onSubmit={handleSubmit} className="profile-form">
          <div className="profile-section">
            <h2 className="profile-section-title">Personal Information</h2>

            <div className="profile-grid">
              <Input label="Name" name="name" value={formData.name} onChange={handleChange} required />
              <Input label="Phone" name="phone" value={formData.phone} onChange={handleChange} required />
            </div>
          </div>

          <div className="profile-section">
            <h2 className="profile-section-title">Pump Information</h2>

            <div className="profile-grid">
              <Input
                label="Pump Name"
                name="pumpName"
                value={formData.pumpName}
                onChange={handleChange}
              />
              <Input
                label="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
              />
              <Input
                label="Rate (₹ per litre)"
                name="rate"
                value={formData.rate}
                onChange={handleChange}
                type="number"
                step="0.01"
              />
            </div>
          </div>

          <div className="profile-actions">
            <Button type="submit" variant="primary" disabled={saving || loadingPump}>
              {saving ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManagerProfile;
